import type { TreeDataNode } from 'antd';
import { FormattedMessage } from 'react-intl';

export interface ExtendedTreeDataNode extends TreeDataNode {
    children?: ExtendedTreeDataNode[];
    type?: 'data' | 'action';
    defaultChecked?: string;
    options?: {
        label: React.ReactNode;
        value: string;
    }[];
}

export const permissionData: ExtendedTreeDataNode[] = [
    {
        title: <FormattedMessage id="pm.Dashboard" />,
        key: 'Dashboard',
        children: [
            {
                title: <FormattedMessage id="pm.Users_Overview" />,
                key: 'Users_Overview',
            },
            {
                title: <FormattedMessage id="pm.Dashboard_Features_Overview" />,
                key: 'Dashboard_Features_Overview',
                children: [
                    {
                        title: <FormattedMessage id="pm.Dashboard_Features_Overview_Export" />,
                        key: 'Dashboard_Features_Overview_Export',
                    },
                ],
            },
        ],
    },
    {
        title: <FormattedMessage id="pm.Users" />,
        key: 'Users',
        children: [
            {
                title: <FormattedMessage id="pm.Users_Users" />,
                key: 'Users_Users',
                children: [
                    {
                        title: <FormattedMessage id="pm.Users_Users_Export" />,
                        key: 'Users_Users_Export',
                    },
                    {
                        title: <FormattedMessage id="pm.Users_Users_Trust" />,
                        key: 'Users_Users_Trust',
                    },
                ],
            },
            {
                title: <FormattedMessage id="pm.Users_Registration-Channels" />,
                key: 'Users_Registration-Channels',
            },
        ],
    },
    {
        title: <FormattedMessage id="pm.Dramas" />,
        key: 'Dramas',
        children: [
            {
                title: <FormattedMessage id="pm.Dramas_Dramas" />,
                key: 'Dramas_Dramas',
                children: [
                    {
                        title: <FormattedMessage id="pm.Dramas_Dramas_Review" />,
                        key: 'Dramas_Dramas_Review',
                    },
                    {
                        title: <FormattedMessage id="pm.Dramas_Dramas_Badge" />,
                        key: 'Dramas_Dramas_Badge',
                    },
                    {
                        title: <FormattedMessage id="pm.Dramas_Dramas_Export" />,
                        key: 'Dramas_Dramas_Export',
                    },
                    {
                        title: <FormattedMessage id="pm.Dramas_Dramas_Offline" />,
                        key: 'Dramas_Dramas_Offline',
                    },
                    {
                        title: <FormattedMessage id="pm.Dramas_Dramas_Heat-Coefficient" />,
                        key: 'Dramas_Dramas_Heat-Coefficient',
                    },
                ],
            },
            {
                title: <FormattedMessage id="pm.Dramas_Comments" />,
                key: 'Dramas_Comments',
                children: [
                    {
                        title: <FormattedMessage id="pm.Dramas_Comments_Delete" />,
                        key: 'Dramas_Comments_Delete',
                    },
                ],
            },
            {
                title: <FormattedMessage id="pm.Dramas_UGC-Reports" />,
                key: 'Dramas_UGC-Reports',
            },
            {
                title: <FormattedMessage id="pm.Dramas_Mining-Weekly-Rewards" />,
                key: 'Dramas_Mining-Weekly-Rewards',
                children: [
                    {
                        title: <FormattedMessage id="pm.Dramas_Mining-Weekly-Rewards_Review" />,
                        key: 'Dramas_Mining-Weekly-Rewards_Review',
                    },
                    {
                        title: <FormattedMessage id="pm.Dramas_Mining-Weekly-Rewards_Export" />,
                        key: 'Dramas_Mining-Weekly-Rewards_Export',
                    },
                ],
            },
            {
                title: <FormattedMessage id="pm.Dramas_Activity-1011" />,
                key: 'Dramas_Activity-1011',
                children: [
                    {
                        title: <FormattedMessage id="pm.Dramas_Activity-1011_Share-Review" />,
                        key: 'Dramas_Activity-1011_Share-Review',
                        children: [
                            {
                                title: <FormattedMessage id="pm.Dramas_Activity-1011_Share-Review_Review" />,
                                key: 'Dramas_Activity-1011_Share-Review_Review',
                            },
                        ],
                    },
                    {
                        title: <FormattedMessage id="pm.Dramas_Activity-1011_User-Stories" />,
                        key: 'Dramas_Activity-1011_User-Stories',
                    },
                    {
                        title: <FormattedMessage id="pm.Dramas_Activity-1011_Task-Config" />,
                        key: 'Dramas_Activity-1011_Task-Config',
                        children: [
                            {
                                title: <FormattedMessage id="pm.Dramas_Activity-1011_Task-Config_Update" />,
                                key: 'Dramas_Activity-1011_Task-Config_Update',
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        title: <FormattedMessage id="pm.Financial-Management" />,
        key: 'Financial-Management',
        children: [
            {
                title: <FormattedMessage id="pm.Financial-Management_Capital-Operation-Records" />,
                key: 'Financial-Management_Capital-Operation-Records',
                children: [
                    {
                        title: <FormattedMessage id="pm.Financial-Management_Capital-Operation-Records_Create" />,
                        key: 'Financial-Management_Capital-Operation-Records_Create',
                    },
                ],
            },
        ],
    },
    {
        title: <FormattedMessage id="pm.Client-Config" />,
        key: 'Client-Config',
        children: [
            {
                title: <FormattedMessage id="pm.Client-Config_App-Version" />,
                key: 'Client-Config_App-Version',
                children: [
                    {
                        title: <FormattedMessage id="pm.Client-Config_App-Version_Create" />,
                        key: 'Client-Config_App-Version_Create',
                    },
                    {
                        title: <FormattedMessage id="pm.Client-Config_App-Version_Update" />,
                        key: 'Client-Config_App-Version_Update',
                    },
                ],
            },
            {
                title: <FormattedMessage id="pm.Client-Config_Content-Filter" />,
                key: 'Client-Config_Content-Filter',
                children: [
                    {
                        title: <FormattedMessage id="pm.Client-Config_Content-Filter_Create" />,
                        key: 'Client-Config_Content-Filter_Create',
                    },
                    {
                        title: <FormattedMessage id="pm.Client-Config_Content-Filter_Update" />,
                        key: 'Client-Config_Content-Filter_Update',
                    },
                    {
                        title: <FormattedMessage id="pm.Client-Config_Content-Filter_Delete" />,
                        key: 'Client-Config_Content-Filter_Delete',
                    },
                ],
            },
            {
                title: <FormattedMessage id="pm.Dramas_Banner" />,
                key: 'Dramas_Banner',
                children: [
                    {
                        title: <FormattedMessage id="pm.Dramas_Banner_Update" />,
                        key: 'Dramas_Banner_Update',
                    },
                ],
            },
        ],
    },
    {
        title: <FormattedMessage id="pm.System-Management" />,
        key: 'System-Management',
        children: [
            {
                title: <FormattedMessage id="pm.System-Management_Accounts" />,
                key: 'System-Management_Accounts',
                children: [
                    {
                        title: <FormattedMessage id="pm.System-Management_Accounts_Create" />,
                        key: 'System-Management_Accounts_Create',
                    },
                    {
                        title: <FormattedMessage id="pm.System-Management_Accounts_Update" />,
                        key: 'System-Management_Accounts_Update',
                    },
                    {
                        title: <FormattedMessage id="pm.System-Management_Accounts_Delete" />,
                        key: 'System-Management_Accounts_Delete',
                    },
                ],
            },
            {
                title: <FormattedMessage id="pm.System-Management_Roles" />,
                key: 'System-Management_Roles',
                children: [
                    {
                        title: <FormattedMessage id="pm.System-Management_Roles_Create" />,
                        key: 'System-Management_Roles_Create',
                    },
                    {
                        title: <FormattedMessage id="pm.System-Management_Roles_Update" />,
                        key: 'System-Management_Roles_Update',
                    },
                    {
                        title: <FormattedMessage id="pm.System-Management_Roles_Delete" />,
                        key: 'System-Management_Roles_Delete',
                    },
                ],
            },
            {
                title: <FormattedMessage id="pm.System-Management_Configs" />,
                key: 'System-Management_Configs',
                children: [
                    {
                        title: <FormattedMessage id="pm.System-Management_Configs_Create" />,
                        key: 'System-Management_Configs_Create',
                    },
                    {
                        title: <FormattedMessage id="pm.System-Management_Configs_Update" />,
                        key: 'System-Management_Configs_Update',
                    },
                    {
                        title: <FormattedMessage id="pm.System-Management_Configs_Delete" />,
                        key: 'System-Management_Configs_Delete',
                    },
                ],
            },
            {
                title: <FormattedMessage id="pm.System-Management_System-Logs" />,
                key: 'System-Management_System-Logs',
            },
        ],
    },
];
